import Markdown from 'react-markdown';
import Link from '@/components/utilities/SmartLink';
import { Icon } from '@/components/ui/icon';

const GlossaryInlineCta = ({ title, description, buttonLabel, buttonLink, icon = 'profile2Users' }) => {
  if (!title && !buttonLabel) return null;

  return (
    <aside className="bg-brand-50 border-brand-200 my-10 flex flex-col items-start gap-6 rounded-2xl border px-7 py-7 xl:flex-row xl:items-center">
      <div className="bg-brand-400 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-white">
        <Icon type={icon} width={24} height={24} />
      </div>
      <div className="flex-1">
        {title && <h3 className="mb-1 text-lg">{title}</h3>}
        {description && (
          <div className="text-grey-700 text-sm leading-relaxed [&_a]:underline [&_p]:m-0">
            <Markdown
              components={{
                a: ({ href, children }) => {
                  const isExternal = href && !href.startsWith('/') && !href.startsWith('#');
                  return (
                    <a href={href} {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                      {children}
                    </a>
                  );
                }
              }}
            >
              {description}
            </Markdown>
          </div>
        )}
      </div>
      {buttonLabel && buttonLink && (
        <Link
          href={buttonLink}
          className="bg-brand-400 hover:bg-brand-500 shrink-0 rounded-full px-7 py-3.5 text-sm font-medium text-white transition-colors"
        >
          {buttonLabel}
        </Link>
      )}
    </aside>
  );
};

export default GlossaryInlineCta;
